import React, {createContext, useEffect, useState} from "react"
import parseToken from "../../../helpers/parseToken"
import {getAllRole} from "../../../services/api/apiUser";
import {message} from "antd";
import {getRoleDataLevel, getRoleObject} from "../../../services/api/apiSwagger";

export const Context = createContext({})

export const Provider = (props) => {
    const [loading, setLoading] = useState(false)
    const [loadingFunc, setLoadingFunc] = useState(false)
    const [loadingData, setLoadingData] = useState(false)
    const [listRoles, setListRoles] = useState([])
    const [listRolesFunction, setListRolesFunction] = useState([])
    const [listRolesFunctionAll, setListRolesFunctionAll] = useState([])
    const [listRolesData, setListRolesData] = useState([])
    const [filters, setFilters] = useState({description: ''})
    const decodeToken = parseToken()
    const [roleSelected, setRoleSelected] = useState('')

    const _fetchListRole = async () => {
        setLoading(true)
        try {
            const response = await getAllRole({}, decodeToken.sub)

            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            setListRoles(data)
            setLoading(false)
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const _fetchListRoleFunction = async () => {
        setLoadingFunc(true)
        try {
            const payload = {
                ...filters,
                roleIds: roleSelected,
                userName: decodeToken.sub
            }
            const response = await getRoleObject(payload)

            const {success, data, error_message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            setListRolesFunction(data)
            setListRolesFunctionAll(data)
            setLoadingFunc(false)
        } catch (e) {
            setLoadingFunc(false)
            message.error(e.message)
        }
    }

    const _fetchListRoleData = async () => {
        setLoadingData(true)
        try {
            const payload = {
                roleIds: roleSelected,
                userName: decodeToken.sub
            }
            const response = await getRoleDataLevel(payload)

            const {success, data, error_message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            setListRolesData(data)
            setLoadingData(false)
        } catch (e) {
            setLoadingData(false)
            message.error(e.message)
        }
    }

    useEffect(() => {
        _fetchListRole()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (roleSelected) _fetchListRoleFunction()
        // eslint-disable-next-line
    }, [roleSelected])

    useEffect(() => {
        if (roleSelected) _fetchListRoleData()
        // eslint-disable-next-line
    }, [roleSelected])

    return (
        <Context.Provider
            value={{
                listRoles,
                listRolesFunction,
                listRolesFunctionAll,
                listRolesData,
                filters,
                loading,
                loadingFunc,
                loadingData,
                fetchListRole: _fetchListRole,
                fetchListRoleData: _fetchListRoleData,
                fetchListRoleFunction: _fetchListRoleFunction,
                setListRolesFunction: setListRolesFunction,
                setFilters: setFilters,
                roleSelected,
                setRoleSelected: setRoleSelected
            }}
        >
            {props.children}
        </Context.Provider>
    )
}

export {
    Context as SettingRoleContext,
    Provider as SettingRoleContextProvider,
} from "./SettingRoleContext"
